require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-2017-01-04-just-in-small-batch-of-jamaican-blue-mountain-in-store-next-week.json") })
        }
      }, "path---blog-2017-01-04-just-in-small-batch-of-jamaican-blue-mountain-in-store-next-week");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-2017-01-04-just-in-small-batch-of-jamaican-blue-mountain-in-store-next-week!./.cache/json/blog-2017-01-04-just-in-small-batch-of-jamaican-blue-mountain-in-store-next-week.json
// module id = 333
// module chunks = 231608221292675